var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"px-10 text-none secondary-action-button",class:_vm.getQaSelectorClass(),attrs:{"color":"primary","outlined":"","data-testid":_vm.testId}},'v-btn',_vm.$props,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }